module.exports = __webpack_public_path__ + "img/icon_do_people@2x.ae84b14d.png";